export const toSnakeCase = (label: string): string =>
  label
    .toLowerCase()
    .match(/[a-z]+\d*|\d+/g)
    ?.join('_') ?? '';
